import { Fragment, useContext, useState, memo, useCallback, useMemo } from "react";
import CalendarLayout from "./CalenderLayout";
import Modal from "../../../../components/controls/modal/Modal";
import ResourceDetailView from "./ResourceDetailView";
import { ResourcePlannerContext } from "../ResourcePlannerContext";

const DayView = memo(({ formBody, dashboard }) => {
  const {
    useDetails,
    calendarHeader,
    calendarData,
    detail,
    setDetail,
  } = useContext(ResourcePlannerContext);
  
  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleCancel = useCallback(() => {
    setShowDetailModal(false);
  }, []);

  const handleClick = useCallback((value) => {
    setShowDetailModal(value);
  }, []);

  // Memoize the date label calculation
  const dateLabel = useMemo(() => {
    if (!detail?.ind || !calendarHeader.length) return "";
    
    const headerValue = new Date().getFullYear(); // You may need to get this from context
    const date = new Date(
      new Date(`${headerValue}-01-01`).setDate(
        new Date(`${headerValue}-01-01`).getDate() + detail.ind + 1
      )
    );
    
    const day = date.toISOString().split("T")[0].split("-")[2];
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.toISOString().split("T")[0].split("-")[0];
    
    return `${day} ${month} ${year}`;
  }, [detail?.ind, calendarHeader]);

  return (
    <Fragment>
      {showDetailModal && (
        <Modal
          title="Resource Details"
          handleCancel={handleCancel}
          handleSave={handleCancel}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={false}
          size="large"
          calendarModalWrap={true}
          body={
            <ResourceDetailView
              formBody={formBody}
              title={"Day"}
              label={dateLabel}
              userDetails={useDetails[detail?.userIndex]}
              shift={{ ...detail.shift }}
            />
          }
        />
      )}
      <CalendarLayout
        dashboard={dashboard}
        userData={useDetails}
        calendarData={calendarData}
        headerDate={calendarHeader}
        handleClick={handleClick}
      />
    </Fragment>
  );
});

DayView.displayName = 'DayView';

export default DayView;
